export default {
  message: {
    pwa: {
      installDisclaimer: "Hay una nueva versión disponible",
      installButton: "Instalar",
      cancelButton: "Descartar",
    },
    hello: "Buenos días",
    yes: "Sí",
    no: "No",
    error: {
      generic: "Ha ocurrido un error",
      noAuthorizated: "Usuario no autorizado",
      fieldRequired: "Campo requerido",
      fieldMin: "Debe introducir al menos {min} caracteres",
      fieldMax: "Puede introducir máximo {max} caracteres",
      fieldEmail: "El email no es válido",
      fieldNumber: "El valor debe ser un número",
      fieldInteger: "El valor debe ser un número entero",
      fieldNumberMin: "Debe ser mayor o igual que {min}",
      fieldNumberExclusiveMin: "Debe ser mayor que {min}",
      fieldNumberMax: "Debe ser menor o igual que {max}",
      fieldNumberExclusiveMax: "Debe ser menor que {max}",
      noSpaces: "No puede contener espacios",
      invalidPassword: "La contraseña no puede contener espacios",
      distinctPassword: "La contraseña no coincide",
      invalidFile: "El fichero es incorrecto",
      invalidImageFileType: "El fichero debe ser jpg, jpeg o png",
      fileSizeMax: "El fichero debe ocupar menos de 500kb",
    },
    vModal: {
      confirm: "Confirmar",
      cancel: "Cancelar",
    },
    login: {
      info: {
        disclaimer: "Para cualquier consulta ponte en contacto con",
      },
      loginPage: {
        email: "Email",
        password: "Contraseña",
        login: "Entrar",
        loginWithGoogle: "Entrar con Google",
        signup: "Registrarse",
        forgotPassword: "He olvidado la contraseña",
        error: "Credenciales incorrectas",
        googleErrorEmailExists: "Este email ya está registrado. Accede con tu email y contraseña.",
        googleErrorCancelled: "Inicio de sesión con Google cancelado.",
        googleError:
          // eslint-disable-next-line max-len
          "No se pudo completar el inicio de sesión con Google. Si ya tienes cuenta, accede con tu email y contraseña.",
        textDonate: "Donar",
      },
      signupPage: {
        headerTitle: "Nuevo usuario",
        back: "Atrás",
        email: "Email",
        password: "Contraseña",
        confirmPassword: "Repetir contraseña",
        alias: "Alias",
        name: "Nombre",
        surname: "Apellidos",
        signup: "Registrarse",
        login: "Ya tengo una cuenta",
        verificationCode: "Código de verificación",
        error: "No se ha podido completar el registro",
        textDisclaimerSpam: `Si no recibe el email con el código de verificación, 
        revise su carpeta de spam`,
      },
      passwordRecoveryPage: {
        headerTitle: "Recuperar contraseña",
        back: "Atrás",
        email: "Email",
        password: "Nueva contraseña",
        confirmPassword: "Repetir contraseña",
        verificationCode: "Código de verificación",
        confirm: "Confirmar",
        error: "No se ha podido modificar la contraseña",
        errorGoogleUser:
          "Tu cuenta usa Google Sign-In. Gestiona tu contraseña desde tu cuenta de Google.",
        textDisclaimerRestartPassword: `Si no recibe el email de 
        restablecimiento de contraseña, revise su carpeta de spam`,
      },
    },
    userDashboard: {
      tabs: {
        groups: "Grupos",
        competitions: "Competiciones",
        matches: "Partidos",
        account: "Cuenta",
        admin: "Admin",
      },
      userGroups: {
        headerTitle: "Grupos",
      },
      userCompetitions: {
        headerTitle: "Competiciones",
        notFinished: "No finalizadas",
        finished: "Finalizadas",
        noCompetitions: "No hay competiciones que mostrar",
      },
      userMatches: {
        headerTitle: "Partidos",
        filterCompetition: "Filtrar por competición",
        filterStatus: "Filtrar por estado",
        allCompetitions: "Todas las competiciones",
        allStatuses: "Todos",
        statusNotFinished: "No finalizados",
        statusUpcoming: "Próximos",
        statusActive: "En juego",
        statusFinished: "Finalizados",
        noMatches: "No hay partidos que mostrar",
        cancel: "Cancelar",
        resultTitle: "Resultado Final",
        activeTitle: "Partido en Curso",
        betsPageTitle: "Mis Apuestas",
        noBetGroups: "No tienes grupos en esta competición",
        noBetsForGroup: "Sin apuestas registradas",
        myBet: "Tu apuesta",
        matchStarted: "Este partido ya ha comenzado, no se pueden registrar apuestas",
        saveBet: "Guardar apuesta",
        betSaved: "Apuesta guardada correctamente",
        summaryVideo: "Resumen del partido",
      },
      userAccount: {
        headerTitle: "Cuenta",
      },
    },
    accountHome: {
      accountInfo: {
        karma: "Karma",
        name: "Nombre",
        surname: "Apellido",
        email: "Email",
        phone: "Teléfono",
        pushNotifications: "Notificaciones push",
        enablePush: "Activar notificaciones",
        pushEnabled: "Notificaciones activas",
        pushEnabledDescription: "Este dispositivo ya está suscrito y puede recibir avisos.",
        pushEnabledToast: "Notificaciones activadas correctamente",
        pushDisabledToast: "Notificaciones push desactivadas para tu cuenta",
        pushInactive: "Notificaciones pendientes de activar",
        pushInactiveDescription:
          "Activa la opción y concede permiso para registrar este dispositivo.",
        pushActionRequired: "Se requiere una acción previa",
        pushBlocked: "Permiso bloqueado",
        pushBlockedDescription:
          "Has bloqueado las notificaciones en el navegador o sistema. " +
          "Debes reactivarlas desde los ajustes.",
        pushDisabledByProfile: "Notificaciones desactivadas en tu cuenta",
        pushDisabledByProfileDescription:
          "Tu usuario no tiene habilitadas las notificaciones push en el servidor.",
        pushEnableError: "No se pudieron activar las notificaciones en este dispositivo",
        pushSettingsUpdateError: "No se pudieron guardar los ajustes de notificaciones",
        logout: "Cerrar sesión",
        edit: "Editar",
        textDonate: "Donar",
        language: "Idioma",
      },
      accountEditInfo: {
        headerTitle: "Editar info",
        confirm: "Confirmar",
        name: "Nombre",
        surname: "Apellido",
        alias: "Alias",
        aliasRegexError: "El alias debe ser una única palabra",
        error: "Error al editar información",
        error409: "Error: Ya existe ese alias",
        altAvatar: "Avatar Usuario",
      },
    },
    createGroup: {
      createGroupView: {
        headerTitle: "Nuevo grupo",
        create: "Crear",
        join: "Unirse",
      },
      selectCompetitionForm: {
        title: "Seleccione una competición",
      },
      groupForm: {
        title: "Datos del grupo",
        name: "Nombre",
        description: "Descripción",
        visible: "Resultado visible",
        repetition: "Permite repetición",
        submit: "Crear grupo",
      },
    },
    groupHome: {
      groupHomeTabs: {
        classification: "Clasificación",
        bets: "Apuestas",
        chat: "Chat",
        messageInfoGroup: "Pulsa para ver la info del grupo",
      },
      groupJoin: {
        codeInvitation: "Código invitación",
        confirm: "Confirmar",
        submit: "Unirse",
        errorJoin: "Error al unirse al grupo. Compruebe su código",
      },
      groupInfo: {
        headerTitle: "Info. del grupo",
        modalCancelLabel: "Atrás",
        modalEditLabel: "Editar",
        addDescription: "Añadir descripción",
        rules: "Reglas",
        settings: "Configuración",
        players: "Jugadores",
        exit: "Salir del grupo",
        confirmExit: `¿Estás seguro que quieres salir del grupo? 
            Esta acción eliminará todas las apuestas actuales en el grupo`,
        warning: "Aviso",
        modal: {},
        exitGroup: "Salir",
      },
      groupInfoEdit: {
        headerTitle: "Info. del grupo",
        confirm: "Confirmar",
        name: "Nombre",
        description: "Descripción",
        altAvatar: "Avatar Usuario",
      },
      playersInfo: {
        headerTitle: "Jugadores",
        search: "Buscar",
        addPlayer: "Añadir jugador",
        admin: "Admin",
        you: "Tú",
        active: "Activo",
        inactive: "Inactivo",
        doAdmin: "Hacer admin",
        doAdminHeader: "¡Atención!",
        doAdminMessage: "Va a hacer administrador del grupo al jugador",
        doAdminError: "Error al hacer administrador del grupo",
        doAdminSuccess: "Admin añadido",
        decline: "Expulsar",
        declineHeader: "¡Atención!",
        declineMessage: "Va a expulsar al jugador del grupo, ¿continuar?",
        invitationGroup: "Enlace de invitación al grupo",
        declineError: "Error al expulsar al jugador",
        declineSuccess: "Jugador expulsado",
      },
      rulesInfo: {
        headerTitle: "Reglas",
        points: "Puntos",
        factor: "Factor",
        placeholder: "Seleccione un equipo",
        cancel: "Cancelar",
        ok: "Aceptar",
        subHeader: "Selecciona el equipo Bonus",
        placeholderRound: "Seleccione una ronda",
        subHeaderRound: "Selecciona la ronda Bonus",
        roundCategory: {
          groups: "GRUPOS",
          eightfinal: "OCTAVOS",
          quaterfinal: "CUARTOS",
          semifinal: "SEMIFINAL",
          final: "FINAL",
          thirdplace: "TERCER PUESTO",
        },
      },
      groupChat: {
        headerTitle: "Chat",
        join: "Unirse al chat de Telegram",
      },
      addPlayer: {
        headerTitle: "Añadir jugador",
        search: "Buscar",
        add: "Añadir",
        confirm: "Confirmar",
        registered: "Ya participa",
      },
      invitationGroup: {
        headerTitle: "Enlace de invitación",
        share: "Compartir",
        copy: "Copiar",
        message: `Cualquier usuario que tenga este enlace podrá unirse al grupo.`,
        name: "Código de invitación",
        copyMessageSuccess: "Código copiado",
        copyMessageError: "Error al copiar el código",
      },
      classification: {
        points: "pts",
        first: "Tête de la course",
        second: "Poursuivant",
        penultimate: "Paquete",
        last: "Farolillo rojo",
        defaultpos: "Pelotón",
      },
      bets: {
        headerTitle: "Apuestas",
        pts: "pts",
        mybet: "Mi apuesta",
        bet: "Apuesta",
        noDate: "Sin fecha",
        betscla: "Apuestas de",
        cancel: "Cancelar",
        all: "Todos",
        finished: "Finalizados",
        notFinished: "No finalizados",
        pending: "Pendientes",
        placeholder: "Filtro de partidos",
        messageNoDataClassiBets: "Este jugador todavía no ha realizado ninguna apuesta",
        messageNoDataMatchBets: "No se ha encontrado ningún partido por ese filtro",
      },
      betModal: {
        cancel: "Cancelar",
        confirm: "Confirmar",
        bet: "Apuesta",
        messageNoBets:
          "Cuando comience el partido podrás ver en esta pantalla las apuestas del resto del grupo",
        stats: "Estadísticas",
      },
      group: {
        cancel: "Cancelar",
        all: "Todos",
        archived: "Archivados",
        actived: "Activos",
        placeholder: "Filtro de grupos",
        messageNoDataGroup: "No se ha encontrado ningún grupo por ese filtro",
      },
    },
    competitionHome: {
      competitionHomeTabs: {
        teams: "Equipos",
        matches: "Partidos",
      },
      competitionInfo: {
        headerTitle: "Info. de competición",
      },
      messageInfoCompetition: "Pulsa para ver la info de la competición",
    },
    admin: {
      headerTitle: "Administración",
      noDate: "No hay fecha",
      list: {
        competitions: "Competiciones",
        notifications: "Notificaciones Push",
        syncConfigs: "Gestión de sincronizaciones",
        stats: "Estadísticas",
        summaryVideos: "Vídeos resumen",
      },
      dashboard: {
        welcome: "Panel de Administración",
        subtitle: "Gestiona competiciones y envía notificaciones a los usuarios",
        competitionsDescription: "Gestiona competiciones, partidos y equipos",
        notificationsDescription: "Envía notificaciones push a todos los usuarios",
        syncConfigsDescription: "Crea y elimina configuraciones de sincronización externas",
        statsDescription: "Consulta métricas globales de usuarios, grupos y actividad",
        summaryVideosDescription: "Añade la URL de YouTube del vídeo resumen de cada partido",
      },
      summaryVideos: {
        headerTitle: "Vídeos resumen",
        competition: "Competición",
        selectCompetition: "Selecciona una competición",
        hint: "Toca un partido para añadir o editar la URL de su vídeo resumen.",
        empty: "No hay partidos en esta competición",
        vs: "vs",
        withVideo: "Con vídeo",
        noVideo: "Sin vídeo",
        urlLabel: "URL del vídeo (YouTube)",
        valid: "URL de YouTube válida",
        invalid: "Debe ser una URL de YouTube (youtube.com o youtu.be)",
        save: "Guardar",
        saved: "Vídeo resumen guardado",
        saveError: "No se pudo guardar el vídeo resumen",
      },
      stats: {
        headerTitle: "Estadísticas",
        heroLabel: "Vista global",
        heroSubtitle: "usuarios registrados en la plataforma",
        heroSummary: "usuarios registrados · {active} activos",
        refresh: "Actualizar",
        retry: "Reintentar",
        errorTitle: "No se pudieron cargar las estadísticas",
        error: "Se ha producido un error al cargar las estadísticas",
        loading: "Cargando estadísticas",
        neverUpdated: "Pendiente de actualizar",
        updatedAt: "Actualizado hace {value}",
        labels: {
          active: "Activos",
          activeGroups: "Grupos activos",
          activeUsers: "Usuarios activos",
          activeUsersInActiveGroups: "Activos en grupos activos",
          googleUsers: "Usuarios con Google",
          maxScore: "Puntuación máxima",
          meanScore: "Media",
          medianScore: "Mediana",
          minScore: "Puntuación mínima",
          newUsers: "Usuarios nuevos (últimas 24h)",
          pushEnabledUsers: "Push activas",
          totalBets: "Apuestas",
          totalCompetitions: "Competiciones",
          totalMatches: "Partidos",
          totalTeams: "Equipos",
          usersWithAvatar: "Con avatar",
          usersWithBets: "Con apuestas",
          totalPlayers: "Jugadores totales",
          scoreRange: "Rango {min}-{max} pts",
        },
        kpis: {
          groups: "Grupos",
          users: "Usuarios",
          playersPerGroup: "Jugadores por grupo",
          pendingMatches: "Partidos pendientes",
          activeOfTotal: "{active} activos de {total}",
          totalPlayers: "{total} jugadores en total",
          totalMatches: "{total} partidos en total",
          totalPlayersCaption: "{total} inscripciones a grupos",
          playersPerGroupCaption: "jugadores / grupo de media",
          allMatchesPlayed: "Todos los partidos disputados",
          pendingMatchesCaption: "Pendientes de {total} partidos",
        },
        sections: {
          usersBreakdown: "Desglose de usuarios",
          users: {
            title: "Usuarios",
            subtitle: "Actividad y adopción",
          },
          players: {
            title: "Jugadores",
          },
          ecosystem: {
            title: "Catálogo",
            subtitle: "Competiciones y volumen",
          },
          classification: {
            title: "Clasificación",
            subtitle: "Distribución de puntuaciones",
          },
        },
      },
      competitions: {
        headerTitle: "Competiciones",
        emptyState: "No hay competiciones disponibles",
        deleteAll: "Borrar todas",
        create: {
          title: "Crear Competición",
        },
        delete: {
          button: "Borrar",
          warning: "Aviso",
          confirmOne: "¿Estás seguro de borrar la competición {name}?",
          confirmAll: "¿Estás seguro de borrar todas las competiciones?",
          success: "Competición borrada correctamente",
          successAll: "Competiciones borradas correctamente",
          error: "Error al borrar la competición",
          errorAll: "Error al borrar las competiciones",
        },
      },
      competition: {
        matchs: {
          title: "Partidos",
          modalTitle: "Modificar partido",
          submitMatch: "Confirmar",
        },
        teams: {
          title: "Equipos",
        },
      },
      teams: {
        headerTitle: "Equipos",
        modal: {
          create: "Crear Equipo",
          edit: "Editar Equipo",
          name: "Nombre",
        },
      },
      notifications: {
        headerTitle: "Notificaciones Push",
        title: "Título",
        titlePlaceholder: "Ingrese el título de la notificación",
        message: "Mensaje",
        messagePlaceholder: "Ingrese el mensaje de la notificación",
        url: "Enlace (opcional)",
        sendButton: "Enviar a todos los usuarios",
        lastResult: "Último resultado",
        successMessage: "Notificación enviada exitosamente",
        errorMessage: "Error al enviar la notificación",
        emojiPicker: {
          title: "Selecciona un emoji",
        },
      },
      syncConfigs: {
        headerTitle: "Gestión de sincronizaciones",
        emptyState: "No hay configuraciones de sincronización disponibles",
        enabled: "Habilitada",
        disabled: "Deshabilitada",
        unknownCompetition: "Competición desconocida",
        create: {
          title: "Crear Sync Config",
          competitionSection: "Competición",
          competitionName: "Nombre",
          competitionCaption: "Caption",
          competitionDescription: "Descripción",
          competitionStartTime: "Fecha de inicio",
          competitionEndTime: "Fecha de fin",
          syncConfigSection: "Sync config",
          label: "Label",
          externalId: "Competition External ID",
          season: "Season",
          submit: "Crear",
          success: "Sync config creada correctamente",
          error: "Se ha producido un error al crear la sync config",
          endTimeAfterStartTime: "La fecha de fin debe ser posterior a la de inicio",
        },
        delete: {
          button: "Borrar",
          success: "Sync config borrada correctamente",
          error: "Se ha producido un error al borrar la sync config",
        },
      },
    },
    pushPrompt: {
      title: "Activar notificaciones",
      message: "Activa las notificaciones push para recibir avisos de tus grupos y competiciones.",
      activate: "Activar",
      dismiss: "Ahora no",
    },
    cookies: {
      toast: {
        disclaimer:
          // eslint-disable-next-line max-len
          "Utilizamos cookies propias y de terceros para analizar el tráfico en nuestro sitio web mediante la obtención de los datos necesarios para estudiar su navegación.",
        configure: "Política de cookies",
        acceptAll: "Aceptar todas",
      },
      cookiesManager: {
        title: "Política de cookies",
        cookiesUsed:
          // eslint-disable-next-line max-len
          "El sitio web utiliza los siguientes tipos de cookies:",
        needed: "Obligatorias",
        neededText:
          // eslint-disable-next-line max-len
          "Cookies estrictamente necesarias para prestar un servicio o contenido solicitado por el usuario. Éstas se encargan de aspectos técnicos como identificar registros y gestionar preferencias de herramientas en el uso, interacción y localización del acceso a los contenidos.",
        analytics: "Estadísticas / Analíticas",
        analyticsText:
          // eslint-disable-next-line max-len
          "Estas cookies recogen información relativa al uso de la página como la permanencia en página y los contenidos visitados por los lectores para medir su rendimiento y mejorar la navegación.",
        accept: "Guardar preferencias",
        acceptAll: "Aceptar Todas",
      },
    },
  },
};
